export const appSettings = {
    refereeContactTypeIndividual: 875970000,
    refereeContactTypeOrganisation: 875970001,
    refereeContactTypeEmployer: 'b90cce41-b1a1-e611-80e6-c4346bad1258',
    refereeContactTypeOtherProfessional: '83be604e-b1a1-e611-80e6-c4346bad1258',
    refereeContactTypeLandlordPrivate: '8c7af330-83aa-e611-80e5-c4346bad621c',
    refereeContactTypeLandlordSocial: 'ebdef136-83aa-e611-80e5-c4346bad621c',
    probityConnectionTypeBoardMember: 'fc81991c-aba9-e611-80d8-000d3a264272',
    probityConnectionTypeEmployee: 'f34ab840-aba9-e611-80d8-000d3a264272',
    probityConnectionTypeToEmployee: 'ee13292f-aba9-e611-80d8-000d3a264272',
    probityConnectionTypeToBoardMember: 'e140464b-37d3-e611-80ea-c4346bad50e4',
    employmentSituationTypeRefused: 'af6a10c7-5b9f-e611-80e6-c4346bacbcbc',
    cantAffordRentMortgage: 'f8c6bfd5-5b9f-e611-80e6-c4346bad102c'
}
